const $ = jQuery;
class Query {
    constructor( config ){
        this.cache = {};
        this.results = {};

        this.request = {
            params: {
                highlightPreTag: '<em class="search-highlight">',
                highlightPostTag: '</em>',
                attributesToSnippet:[
                    'content:10'
                ],
                getRankingInfo: true
            }
        };

        $.extend( true, this, config || {});
    }

    getAlgoliaRequest( term ){
        return $.extend(true, {}, this.request, {
            query: term
        });
    }

    hasResults() {
        return this.results && this.results.hits;
    }

    resultsError( err ){
        this.results = [];
    }

    search( term ){
        term = term.toLowerCase().trim();
        return new Promise( (resolve, reject) => {
            if( this.cache[term] ){
                this.results = this.cache[term];
                if( this.target ){
                    this.target.hits = this.cache[term].hits;
                    this.target.response = this.cache[term];
                }
                return resolve( this.cache[term].hits );
            }
            this.client.query( this.getAlgoliaRequest(term) ).then( results => {
                this.cache[term] = results;
                if( this.target ){
                    this.target.hits = this.cache[term].hits;
                    this.target.response = this.cache[term];
                }
                return resolve( this.cache[term] );
            });
        });
    }

    hasMore(){
        
    }

    async more(){

    }
}

const queries = {
    all: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Recommend Results',
            request: {
                indexName: 'asa_searchable_posts',
                params: {
                    hitsPerPage: 4
                }
            }
        }, config || {} ) );
    },
    pagesAndArticles: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Pages &amp; Articles',
            request: {
                indexName: 'asa_searchable_posts',
                params: {
                    facetFilters: [
                        'is_event:false',
                        [
                            "post_type_label:Posts",
                            "post_type_label:Pages"
                        ]
                    ],
                    hitsPerPage: 4
                }
            }
        }, config || {} ) );
    },
    events: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Events',
            request: {
                indexName: 'asa_searchable_posts',
                params: {
                    facetFilters: [
                        "is_event:true"
                    ],
                    hitsPerPage: 3
                }
            }
        }, config || {} ) );
    },
    publications: (config) => {
        return new Query( $.extend( true, {}, {
    
            label: 'Publications',
            request: {
                indexName: 'asa_searchable_posts',
                params: {
                    facetFilters: [
                        "post_type_label:Issues"
                    ],
                    hitsPerPage: 3
                }
            }
        }, config || {} ) );
    },
    suppliers: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Industry Suppliers',
            request: {
                indexName: 'suppliers_searchable_posts',
                params: {
                    hitsPerPage: 3
                }
            }
        }, config || {} ) );
    },
    marketplace: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'ASA Marketplace',
            request: {
                indexName: 'marketplace_searchable_posts',
                params: {
                    hitsPerPage: 3
                }
            }
        }, config || {} ) );
    },
    staffingToday: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Staffing Today',
            request: {
                indexName: 'st_searchable_posts',
                params: {
                    hitsPerPage: 3
                }
            }
        }, config || {} ) );
    },
    techCompanies: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Tech Companies',
            request: {
                indexName: 'asa_searchable_posts',
                params: {
                    facetFilters: [
                        'is_event:false',
                        [
                            "post_type_label:Tech Companies"
                        ]
                    ],
                    hitsPerPage: 4
                }
            }
        }, config || {} ) );
    },
    sw: (config) => {
        return new Query( $.extend( true, {}, {
            label: 'Staffing World',
            request: {
                indexName: 'sw23_searchable_posts',
                params: {
                    hitsPerPage: 4
                }
            }
        }, config || {} ) );
    }
};

class SearchWrapper {

    constructor( client ){
        this.client = client;
        this.queries = [];
    }

    query( req ){
        return this.batch( req );
    }

    queue(){
        if( !this.current ) {
            this.current = new Promise( (resolve, reject) => {
                setTimeout( () => {
                    const queries = this.queries;
                    this.client.search(queries, (err, response) => {
                        if( err || !response.results ){
                            reject( err );
                        }
                        else {
                            resolve( response.results );
                        }
                    });
                    this.current = false;
                    this.queries = [];
                }, 1 );
            });
        }
        return this.current;
    }

    batch( req ){
        return new Promise( (resolve, reject) => {
            const i = this.queries.length;
            this.queries.push( req );
            this.queue( req ).then( results => {
                resolve( results[i] );
            });
        });
    }

}
export {
    queries, SearchWrapper
};